(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('[id^="cpc-track-"]').forEach(function (track) {
    var sectionId = track.id.replace('cpc-track-', '');
    var prevBtn   = document.getElementById('cpc-prev-'    + sectionId);
    var nextBtn   = document.getElementById('cpc-next-'    + sectionId);
    var counter   = document.getElementById('cpc-counter-' + sectionId);
    var cards     = Array.from(track.children);
    var total     = cards.length;

    if (!total || !prevBtn || !nextBtn || !counter) return;

    var currentIdx     = 0;
    var isInitializing = false; /* guard: skip scroll handler during init scroll */

    /* ─────────────────────────────────────────────────────────────
       STEP 1 — Synchronous immediate update.
       Show the correct total right now, before any rAF fires.
       This prevents the stale HTML "1 / 1" from ever being visible.
    ───────────────────────────────────────────────────────────── */
    updateUI(0);

    /* ── Update counter & button states ── */
    function updateUI(idx) {
      currentIdx = Math.max(0, Math.min(idx, total - 1));
      counter.textContent = (currentIdx + 1) + ' / ' + total;
      prevBtn.disabled = (currentIdx === 0);
      nextBtn.disabled = (currentIdx === total - 1);
    }

    /* ── Scroll so card[idx] aligns to the left snap point ── */
    function scrollToCard(idx) {
      var card = cards[Math.max(0, Math.min(idx, total - 1))];
      if (!card) return;
      var padLeft    = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var targetLeft = card.offsetLeft - padLeft;
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    /* ── Scroll handler — rAF throttled, guarded during init ── */
    var scrollRaf;
    track.addEventListener('scroll', function () {
      if (isInitializing) return; /* ignore the scroll triggered by init */
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(function () {
        var padLeft  = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var snapLine = track.scrollLeft + padLeft;
        var closest  = 0;
        var minDist  = Infinity;
        cards.forEach(function (card, i) {
          var dist = Math.abs(card.offsetLeft - snapLine);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        updateUI(closest);
      });
    }, { passive: true });

    /* ── Nav button clicks — optimistic counter update ── */
    prevBtn.addEventListener('click', function () {
      var target = Math.max(0, currentIdx - 1);
      updateUI(target);
      scrollToCard(target);
    });
    nextBtn.addEventListener('click', function () {
      var target = Math.min(total - 1, currentIdx + 1);
      updateUI(target);
      scrollToCard(target);
    });

    /* ── Horizontal wheel scroll ── */
    track.addEventListener('wheel', function (e) {
      var dx = e.deltaX, dy = e.deltaY;
      var ax = Math.abs(dx),  ay = Math.abs(dy);
      if (ax > 1 && ax >= ay) {
        e.preventDefault();
        track.scrollLeft += dx;
      } else if (e.shiftKey && ay > 1) {
        e.preventDefault();
        track.scrollLeft += dy;
      }
    }, { passive: false });

    /* ── Mouse drag-to-scroll ── */
    var isDragging = false, dragStartX = 0, dragScrollL = 0, movedPx = 0;

    track.addEventListener('mousedown', function (e) {
      isDragging = true; movedPx = 0;
      dragStartX = e.pageX; dragScrollL = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var walk = e.pageX - dragStartX;
      movedPx = Math.abs(walk);
      track.scrollLeft = dragScrollL - walk;
    });
    track.addEventListener('click', function (e) {
      if (movedPx > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    track.querySelectorAll('img, a').forEach(function (el) {
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    /* ─────────────────────────────────────────────────────────────
       STEP 2 — Deferred scroll-offset init (hidden-first-card effect).

       Retries every frame until offsetWidth > 0 (layout is ready).
       isInitializing flag prevents the scroll event from overwriting
       the counter while we programmatically set scrollLeft.
    ───────────────────────────────────────────────────────────── */
    var initRetries = 0;
    function tryInit() {
      if (total < 2) return; /* single card — 1/1 is correct, nothing to hide */

      var firstCard = cards[0];
      var cardWidth = firstCard.offsetWidth;

      if (cardWidth === 0 && initRetries < 60) {
        /* Layout not ready yet — wait one more frame */
        initRetries++;
        requestAnimationFrame(tryInit);
        return;
      }

      if (cardWidth === 0) return; /* Give up after ~1 second */

      var gap           = parseFloat(getComputedStyle(track).gap) || 16;
      var initialOffset = firstCard.offsetLeft + cardWidth + gap;

      /* Guard: prevent the scroll event from fighting us */
      isInitializing = true;
      track.scrollLeft = initialOffset;
      updateUI(1); /* Card 2 is now at the left snap point */

      /* Lift guard after one frame (scroll event will have fired by then) */
      requestAnimationFrame(function () { isInitializing = false; });
    }

    requestAnimationFrame(tryInit);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
